import { Amplify } from "aws-amplify"
import config from "./config"

// Initialize Amplify configuration immediately when this module is imported
// This must be imported before any other modules that use AWS Amplify auth

Amplify.configure(
  {
    Auth: {
      Cognito: {
        userPoolId: config.awsUserPoolId,
        userPoolClientId: config.awsUserPoolClientId,
      },
    },
  },
  {
    ssr: false,
  },
)

export default Amplify
